import React from "react";
import { ICouponCard, INextBestCoupon, CouponInfo } from "@swiggy-private/core-ui";
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { IFetchCouponsParams } from "@cart-client/hooks/types";
import { MROCouponClashPopup } from "@swiggy-private/cart-types";

export interface CouponListingContextValue {
    isFetching: boolean;
    fetchCoupons: (params: IFetchCouponsParams) => void;
    isApplyingCoupon: boolean;
    isRemovingCoupon?: boolean;
    errorMessage: string;
    clearErrorMessage: VoidFunction;
    coupons: ICouponCard[] | null;
    nextBestCoupon: INextBestCoupon | null;
    resetCouponListingPage: VoidFunction;
    tncCoupon?: CouponInfo | null;
    setTncCoupon?: (coupon: CouponInfo | null) => void;
    cards: IPLWidgetControllerCards[];
    hasInitiallyFetched?: boolean;
    hasApplyCouponInitiated?: boolean;
    applyCouponClashPopup?: MROCouponClashPopup;
}

export const CouponListingContext = React.createContext<CouponListingContextValue>({
    isFetching: false,
    isApplyingCoupon: false,
    isRemovingCoupon: false,
    coupons: null,
    errorMessage: "",
    clearErrorMessage: () => void 0,
    nextBestCoupon: null,
    fetchCoupons: () => void 0,
    resetCouponListingPage: () => void 0,
    tncCoupon: null,
    setTncCoupon: () => void 0,
    cards: [],
    hasInitiallyFetched: false,
    hasApplyCouponInitiated: false,
});

if (__DEV__) {
    CouponListingContext.displayName = "CouponListingContext";
}
